export default __webpack_public_path__ + "static/lbo-fund-bg-7a41ba6d43b5560a1cc92d5531fbf00c.jpeg";